import { OnInit, ViewChild, Component } from "@angular/core";
import { MatTableDataSource, MatDialog } from "@angular/material";
import { SearchFilterComponent } from "../../../search-filter/search-filter.component";
import { Router } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { MenuService } from "../../../../services/menu.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import {
  SearchFilter,
  IFilterResponse,
} from "../../../../infrastructure/iFilter-component";
import { PatientCashDeskSeachItem } from "../../../../model/patient/patient-pending-cash-desk-search-item";
import { NotificationToastService } from "../../../../services/notification-toast.service";
import { CashDeskManualSearchItem } from "../../../../model/cash-desk-manual-search-item";
import { PagerControlComponent } from "../../../controls/pager/pager-control.component";
import { InvoiceManualCashDeskService } from "src/app/services/invoice-cash-desk/invoice-manual-cash-desk.service";
import { PatientService } from "src/app/services/patient.service";
import { PatientMailEditDialogComponent } from "src/app/components/dialogs/patient-mail-edit-dialog/patient-mail-edit-dialog.component";

@Component({
  selector: "cash-desk-manual-search",
  templateUrl: "./cash-desk-manual-search.component.html",
  styleUrls: ["./cash-desk-manual-search.component.css"],
  providers: [InvoiceManualCashDeskService],
})
export class CashDeskManualSearchComponent implements OnInit {
  loading: boolean;
  cashDeskManualSearchItems: CashDeskManualSearchItem[] = [];
  searchFilters: SearchFilter[];
  displayedColumns: string[] = [
    "Number",
    "InvoiceTypeDescription",
    "BusinessName",
    "CreateDateView",
    "Amount",
    "Protocol",
    "Star",
  ];
  dataSource = new MatTableDataSource([]);
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  constructor(
    private router: Router,
    private patientService: PatientService,
    public dialog: MatDialog,
    private menuService: MenuService,
    private ivoiceManualCashDeskService: InvoiceManualCashDeskService,
    private notificationToastService: NotificationToastService
  ) {
    this.menuService.setMenuTitle("Cobranza", "Manual");
  }

  ngOnInit(): void {}

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<CashDeskManualSearchItem>) {
    this.cashDeskManualSearchItems = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.cashDeskManualSearchItems);
  }

  onStartSearch() {
    this.loading = true;
  }

  canCreateCreditNote(item: CashDeskManualSearchItem): boolean {
    return item.CanCreateCreditNote;
  }

  invoiceManualCreditNoteCashDeskRedirect(
    item: CashDeskManualSearchItem
  ): void {

    if (item.AppointmentIds && item.AppointmentIds.length > 0) {
      this.router.navigate([
        "invoice-manual-credit-note-cash-desk-edit",
        item.Id,
        item.AppointmentIds[0],
      ]);
    } else {
      this.router.navigate([
        "invoice-manual-credit-note-cash-desk-edit",
        item.Id,
      ]);
    }

  }

  invoiceManualCashDeskRedirect(): void {
    this.router.navigate(["invoice-manual-cash-desk-edit"]);
  }

  invoiceManualCashDeskViewRedirect(item: CashDeskManualSearchItem): void {
    const appointmentId =
      item.AppointmentIds && item.AppointmentIds.length > 0
        ? item.AppointmentIds[0]
        : null;
    if (appointmentId) {
      this.router.navigate([
        "invoice-manual-cash-desk-view",
        item.Id,
        appointmentId,
      ]);
    } else {
      this.router.navigate(["invoice-manual-cash-desk-view", item.Id]);
    }
  }

  async sendMail(item: CashDeskManualSearchItem) {
    try {
      if (item.AppointmentIds && item.AppointmentIds.length > 0) {
        const patientMail =
          await this.patientService.getPatientMailByAppointmentId(
            item.AppointmentIds[0]
          );

        const dialogRef = this.dialog.open(PatientMailEditDialogComponent, {
          width: "50%",
          data: patientMail,
        });

        const result = await dialogRef.afterClosed().toPromise();

        if (result) {
          await this.ivoiceManualCashDeskService.sendMailPatientInvoiceCashDeskPdf(
            item.Id,
            item.AppointmentIds[0],
            null,
            result
          );
        }
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err.error), "Factura");
    }
  }
}
